import { AcceptInvoiceTermsModal } from '#app/components/Modals/V2/GlobalModalSystem/templates/AcceptInvoiceTermsModal.js';
import { type AddContactModal } from '#app/components/Modals/V2/GlobalModalSystem/templates/AddContactModal.js';
import { ClientCreditIssuanceModal } from '#app/components/Modals/V2/GlobalModalSystem/templates/ClientCreditIssuanceModal.js';
import { type CompliantContractsEducationModal } from '#app/components/Modals/V2/GlobalModalSystem/templates/CompliantContractsEducationModal.js';
import { DeletePaymentMethodModal } from '#app/components/Modals/V2/GlobalModalSystem/templates/DeletePaymentMethodModal.js';
import { type FileSupportRequestModal } from '#app/components/Modals/V2/GlobalModalSystem/templates/FileSupportRequestModal.js';
import { type HireOptionsModal } from '#app/components/Modals/V2/GlobalModalSystem/templates/HireOptionsModal.js';
import { PaymentMethodAttachedToProjectsModal } from '#app/components/Modals/V2/GlobalModalSystem/templates/PaymentMethodAttachedToProjectsModal.js';
import { ProposalBillingTypeEducationModal } from '#app/components/Modals/V2/GlobalModalSystem/templates/ProposalBillingTypeEducationModal.js';
import { ProposalEscrowBillingEducationModal } from '#app/components/Modals/V2/GlobalModalSystem/templates/ProposalEscrowBillingEducationModal.js';
import { ProposalInvoiceBillingEducationModal } from '#app/components/Modals/V2/GlobalModalSystem/templates/ProposalInvoiceBillingEducationModal.js';
import { ScheduleInvoicePaymentModal } from '#app/components/Modals/V2/GlobalModalSystem/templates/ScheduleInvoicePaymentModal.js';
import { type ServiceInquiryModal } from '#app/components/Modals/V2/GlobalModalSystem/templates/ServiceInquiryModal.js';
import { SocialPostEngagementModal } from '#app/components/Modals/V2/GlobalModalSystem/templates/SocialPostEngagementModal.js';
import { type PropertyModalName } from '#app/types/analytics/propertyLibrary.js';
import { IndyDashboardWelcomeModal } from './templates//IndyDashboardWelcomeModal.js';
import { type AbandonEditableFlowModal } from './templates/AbandonEditableFlowModal.js';
import { type AddNewProjectModal } from './templates/AddNewProjectModal.js';
import { type AddOrganizationModal } from './templates/AddOrganizationModal.js';
import { type AddTaxInformationModal } from './templates/AddTaxInformationModal.js';
import { AddTaxInformationToProjectTermsModal } from './templates/AddTaxInformationToProjectTermsModal.js';
import { type AddToUserListsModal } from './templates/AddToUserListsModal.js';
import { AdvancedNetworkUpgradeModal } from './templates/AdvancedNetworkUpgradeModal.js';
import { AdvancedSearchUpgradeModal } from './templates/AdvancedSearchUpgradeModal.js';
import { AnonymousJobCreationModal } from './templates/AnonymousJobCreationModal.js';
import { type AppliedToContestModal } from './templates/AppliedToContestModal.js';
import { type ApplyToJobModal } from './templates/ApplyToJobModal.js';
import { type ApplyToJobUnauthenticatedModal } from './templates/ApplyToJobUnauthenticatedModal.js';
import { type ApproveMilestoneModal } from './templates/ApproveMilestoneModal.js';
import { type ApproveWorkConfirmationModal } from './templates/ApproveWorkConfirmationModal.js';
import { type AuthenticationModal } from './templates/AuthenticationModal.js';
import { type BonusFormModal } from './templates/BonusFormModal.js';
import { type BoostedJobsModal } from './templates/BoostedJobsModal.js';
import { type BoostSocialPostModal } from './templates/BoostSocialPostModal.js';
import { type BoostYourApplicationModal } from './templates/BoostYourApplicationModal.js';
import { type BrandCustomizationModal } from './templates/BrandCustomizationModal.js';
import { type BrandCustomizationSuccessModal } from './templates/BrandCustomizationSuccessModal.js';
import { CancelContraProModal } from './templates/CancelContraProModal.js';
import { type CancelDisputeProjectModal } from './templates/CancelDisputeProjectModal.js';
import { type ClientCongratsLiveProjectModal } from './templates/ClientCongratsLiveProjectModal.js';
import { type ClientOnboardingAbandonFlowModal } from './templates/ClientOnboardingAbandonFlowModal.js';
import { type ClientOnboardingRedirectionModal } from './templates/ClientOnboardingRedirectionModal.js';
import { type ClientSignUpAbandonFlowModal } from './templates/ClientSignUpAbandonFlowModal.js';
import { type ClientSubscriptionCustomizationModal } from './templates/ClientSubscriptionCustomizationModal.js';
import { type ClientWorkspaceSubscriptionModal } from './templates/ClientWorkspaceSubscriptionModal.js';
import { type ClientWorkspaceSubscriptionSuccessModal } from './templates/ClientWorkspaceSubscriptionSuccessModal.js';
import { CompleteSignUpModal } from './templates/CompleteSignUpModal.js';
import { type DeclineMilestoneModal } from './templates/DeclineMilestoneModal.js';
import { DeclineProposalChangeRequestModal } from './templates/DeclineProposalChangeRequestModal.js';
import { type DeclineWorkConfirmationModal } from './templates/DeclineWorkConfirmationModal.js';
import { type DeleteAccountModal } from './templates/DeleteAccountModal.js';
import { DeleteChatMessageWarningModal } from './templates/DeleteChatMessageWarningModal.js';
import { type DeleteDomainConfirmationModal } from './templates/DeleteDomainConfirmationModal.js';
import { DeleteNetworkViewModal } from './templates/DeleteNetworkViewModal.js';
import { type DeleteResourceModal } from './templates/DeleteResourceModal.js';
import { DeleteUserListModal } from './templates/DeleteUserListModal.js';
import { type DeleteWorkspaceDocumentModal } from './templates/DeleteWorkspaceDocumentModal.js';
import { DemoBookedModal } from './templates/DemoBookedModal.js';
import { type DepositMilestonePaymentModal } from './templates/DepositMilestonePaymentModal.js';
import { type DisableWorkWithMeConfirmationModal } from './templates/DisableWorkWithMeConfirmationModal.js';
import { type DiscardChangesModal } from './templates/DiscardChangesModal.js';
import { type DiscardConfirmationModal } from './templates/DiscardConfirmationModal.js';
import { DiscoverabilityEducationModal } from './templates/DiscoverabilityEducationModal.js';
import { type DiscoverableOnContraModal } from './templates/DiscoverableOnContraModal.js';
import { DiscoverUnauthenticatedInquiryModal } from './templates/DiscoverUnauthenticatedInquiryModal.js';
import { type DocumentSignedFTUEModal } from './templates/DocumentSignedFTUEModal.js';
import { type DocumentTemplateUploadModal } from './templates/DocumentTemplateUploadModal.js';
import { type DocumentUploadModal } from './templates/DocumentUploadModal.js';
import { type EditOrganizationModal } from './templates/EditOrganizationModal.js';
import { type EditPaymentMethodModalV2 } from './templates/EditPaymentMethodModalV2.js';
import { type EditProjectPaymentMethodModal } from './templates/EditProjectPaymentMethodModal.js';
import { type EditSocialLinksModal } from './templates/EditSocialLinksModal.js';
import { ExitOpportunityChangesModal } from './templates/ExitOpportunityChangesModal.js';
import { FinanceIntegrationClientSubscriptionUpsellModal } from './templates/FinanceIntegrationClientSubscriptionUpsellModal.js';
import { FinanceIntegrationSurveyModal } from './templates/FinanceIntegrationSurveyModal.js';
import { type GenericConfirmationModal } from './templates/GenericConfirmationModal.js';
import { type GoProBrandCustomizationModal } from './templates/GoProBrandCustomizationModal.js';
import { type GoProWaivePlatformFeesModal } from './templates/GoProWaivePlatformFeesModal.js';
import { type GuestJobApplicationVerifyEmailModal } from './templates/GuestJobApplicationVerifyEmailModal.js';
import { type GuestPaymentSuccessModal } from './templates/GuestPaymentSuccessModal.js';
import { type IncompleteProfileModal } from './templates/IncompleteProfileModal.js';
import { type IndependentCongratsLiveProjectModal } from './templates/IndependentCongratsLiveProjectModal.js';
import { IndyCompliantContractsEducationModal } from './templates/IndyCompliantContractsEducationModal.js';
import { type IndyOnboardingAbandonFlowModal } from './templates/IndyOnboardingAbandonFlowModal.js';
import { type IndyOnboardingRedirectionModal } from './templates/IndyOnboardingRedirectionModal.js';
import { type IndyPortfolioSubscriptionModal } from './templates/IndyPortfolioSubscriptionModal.js';
import { type IndyPortfolioSubscriptionSuccessModal } from './templates/IndyPortfolioSubscriptionSuccessModal.js';
import { type IndySignUpAbandonFlowModal } from './templates/IndySignUpAbandonFlowModal.js';
import { InviteContactModal } from './templates/InviteContactModal.js';
import { type InvitedContractorCompanyCollaborationModal } from './templates/InvitedContractorCompanyCollaborationModal.js';
import { type InviteTeammatesModal } from './templates/InviteTeammatesModal.js';
import { type JobApplicationSocialShareModal } from './templates/JobApplicationSocialShareModal.js';
import { type JobCreationModal } from './templates/JobCreationModal.js';
import { JobOrContestCreationModal } from './templates/JobOrContestCreationModal.js';
import { JobPostingVisibilityModal } from './templates/JobPostingVisibilityModal.js';
import { type JustSubscribedToProModal } from './templates/JustSubscribedToProModal.js';
import { type LiveProjectCompleteOnboardingModal } from './templates/LiveProjectCompleteOnboardingModal.js';
import { type LogoutModal } from './templates/LogoutModal.js';
import { type ManageEntityOwnerModal } from './templates/ManageEntityOwnerModal.js';
import { type MarkApplicantAsContestantModal } from './templates/MarkApplicantAsContestantModal.js';
import { type MarkApplicantAsExpertModal } from './templates/MarkApplicantAsExpertModal.js';
import { type MarkContestantAsWinnerModal } from './templates/MarkContestantAsWinnerModal.js';
import { type MessageSentModal } from './templates/MessageSentModal.js';
import { MoreReviewsModal } from './templates/MoreReviewsModal.js';
import { type NewFeaturesUnlockedModal } from './templates/NewFeaturesUnlockedModal.js';
import { PendingPaymentLoadingStateModal } from './templates/PendingPaymentLoadingStateModal.js';
import { type PostJobBoostSubscribeModal } from './templates/PostJobBoostSubscribeModal.js';
import { type PrimarySkillChangedWarningModal } from './templates/PrimarySkillChangedWarningModal.js';
import { type ProfileMagicInputErrorModal } from './templates/ProfileMagicInputErrorModal.js';
import { type ProfileMagicInputModal } from './templates/ProfileMagicInputModal.js';
import { type ProjectInReviewModal } from './templates/ProjectInReviewModal.js';
import { type ReadyToSubmitConfirmationModal } from './templates/ReadyToSubmitConfirmationModal.js';
import { type RecoverUnsavedChangesModal } from './templates/RecoverUnsavedChangesModal.js';
import { ReferralC4cInviteModal } from './templates/ReferralC4cInviteModal.js';
import { ReferralInviteModal } from './templates/ReferralInviteModal.js';
import { type RemoveContactWarningModal } from './templates/RemoveContactWarningModal.js';
import { RemoveWorkspaceMemberModal } from './templates/RemoveWorkspaceMemberModal.js';
import { ReplySocialPost } from './templates/ReplySocialPost.js';
import { RequestMembershipModal } from './templates/RequestMembershipModal.js';
import { type RequestProposalRevisionModal } from './templates/RequestProposalRevisionModal.js';
import { type RequestRevisionOngoingProjectSubmissionModal } from './templates/RequestRevisionOngoingProjectSubmissionModal.js';
import { type RequestToWorkModal } from './templates/RequestToWorkModal.js';
import { type ResolveBulkPaymentCSVImportIssuesModal } from './templates/ResolveBulkPaymentCSVImportIssuesModal.js';
import { type SampleDestructiveModal } from './templates/SampleDestructiveModal.js';
import { type SampleFullscreenMobileModal } from './templates/SampleFullscreenMobileModal.js';
import { type SampleHeroImageModal } from './templates/SampleHeroImageModal.js';
import { type SampleRegularModal } from './templates/SampleRegularModal.js';
import { type SaveAsDraftModal } from './templates/SaveAsDraftModal.js';
import { SaveUserSignUpModal } from './templates/SaveUserSignUpModal.js';
import { SearchFiltersModal } from './templates/SearchFiltersModal.js';
import { type SearchPreviewEndedModal } from './templates/SearchPreviewEndedModal.js';
import { type SelectProjectsModal } from './templates/SelectProjectsModal.js';
import { type SendDocumentModal } from './templates/SendDocumentModal.js';
import { ShareAndInviteToJobModal } from './templates/ShareAndInviteToJobModal.js';
import { ShareSocialPostModal } from './templates/ShareSocialPostModal.js';
import { SlideOutWorkspaceMemberModal } from './templates/SlideOutWorkspaceMemberModal.js';
import { SocialPostImagesModal } from './templates/SocialPostImagesModal.js';
import { SocialPostOnboardingModal } from './templates/SocialPostOnboardingModal.js';
import { type SubmitMilestoneModal } from './templates/SubmitMilestoneModal.js';
import { type SubmittedContestEntryModal } from './templates/SubmittedContestEntryModal.js';
import { type SuccessfulBonusPaymentModal } from './templates/SuccessfulBonusPaymentModal.js';
import { UpdateAvailabilityModal } from './templates/UpdateAvailabilityModal.js';
import { type UpdateJobDetailsBeforePostingModal } from './templates/UpdateJobDetailsBeforePostingModal.js';
import { type UserAvailabilityModal } from './templates/UserAvailabilityModal.js';
import { type VideoModal } from './templates/VideoModal.js';
import { type ViewOwnJobApplicationModal } from './templates/ViewOwnJobApplicationModal.js';
import { type WelcomeToYourCompanyProfileModal } from './templates/WelcomeToYourCompanyProfileModal.js';
import { type WorkspaceDocumentTemplatesModal } from './templates/WorkspaceDocumentTemplatesModal.js';
import { type ModalTemplateKeys } from './types.js';

export type MODAL_MAP = {
  AbandonEditableFlowModal: typeof AbandonEditableFlowModal;
  AcceptInvoiceTermsModal: typeof AcceptInvoiceTermsModal;
  AddContactModal: typeof AddContactModal;
  AddNewProjectModal: typeof AddNewProjectModal;
  AddOrganizationModal: typeof AddOrganizationModal;
  AddTaxInformationModal: typeof AddTaxInformationModal;
  AddTaxInformationToProjectTermsModal: typeof AddTaxInformationToProjectTermsModal;
  AddToUserListsModal: typeof AddToUserListsModal;
  AdvancedNetworkUpgradeModal: typeof AdvancedNetworkUpgradeModal;
  AdvancedSearchUpgradeModal: typeof AdvancedSearchUpgradeModal;
  AnonymousJobCreationModal: typeof AnonymousJobCreationModal;
  AppliedToContestModal: typeof AppliedToContestModal;
  ApplyToJobModal: typeof ApplyToJobModal;
  ApplyToJobUnauthenticatedModal: typeof ApplyToJobUnauthenticatedModal;
  ApproveMilestoneModal: typeof ApproveMilestoneModal;
  ApproveWorkConfirmationModal: typeof ApproveWorkConfirmationModal;
  AuthenticationModal: typeof AuthenticationModal;
  BonusFormModal: typeof BonusFormModal;
  BoostedJobsModal: typeof BoostedJobsModal;
  BoostSocialPostModal: typeof BoostSocialPostModal;
  BoostYourApplicationModal: typeof BoostYourApplicationModal;
  BrandCustomizationModal: typeof BrandCustomizationModal;
  BrandCustomizationSuccessModal: typeof BrandCustomizationSuccessModal;
  CancelContraProModal: typeof CancelContraProModal;
  CancelDisputeProjectModal: typeof CancelDisputeProjectModal;
  ClientCongratsLiveProjectModal: typeof ClientCongratsLiveProjectModal;
  ClientCreditIssuanceModal: typeof ClientCreditIssuanceModal;
  ClientOnboardingAbandonFlowModal: typeof ClientOnboardingAbandonFlowModal;
  ClientOnboardingRedirectionModal: typeof ClientOnboardingRedirectionModal;
  ClientSignUpAbandonFlowModal: typeof ClientSignUpAbandonFlowModal;
  ClientSubscriptionCustomizationModal: typeof ClientSubscriptionCustomizationModal;
  ClientWorkspaceSubscriptionModal: typeof ClientWorkspaceSubscriptionModal;
  ClientWorkspaceSubscriptionSuccessModal: typeof ClientWorkspaceSubscriptionSuccessModal;
  CompleteSignUpModal: typeof CompleteSignUpModal;
  CompliantContractsEducationModal: typeof CompliantContractsEducationModal;
  DeclineMilestoneModal: typeof DeclineMilestoneModal;
  DeclineProposalChangeRequestModal: typeof DeclineProposalChangeRequestModal;
  DeclineWorkConfirmationModal: typeof DeclineWorkConfirmationModal;
  DeleteAccountModal: typeof DeleteAccountModal;
  DeleteChatMessageWarningModal: typeof DeleteChatMessageWarningModal;
  DeleteDomainConfirmationModal: typeof DeleteDomainConfirmationModal;
  DeleteNetworkViewModal: typeof DeleteNetworkViewModal;
  DeletePaymentMethodModal: typeof DeletePaymentMethodModal;
  DeleteResourceModal: typeof DeleteResourceModal;
  DeleteUserListModal: typeof DeleteUserListModal;
  DeleteWorkspaceDocumentModal: typeof DeleteWorkspaceDocumentModal;
  DemoBookedModal: typeof DemoBookedModal;
  DepositMilestonePaymentModal: typeof DepositMilestonePaymentModal;
  DisableWorkWithMeConfirmationModal: typeof DisableWorkWithMeConfirmationModal;
  DiscardChangesModal: typeof DiscardChangesModal;
  DiscardConfirmationModal: typeof DiscardConfirmationModal;
  DiscoverabilityEducationModal: typeof DiscoverabilityEducationModal;
  DiscoverableOnContraModal: typeof DiscoverableOnContraModal;
  DiscoverUnauthenticatedInquiryModal: typeof DiscoverUnauthenticatedInquiryModal;
  DocumentSignedFTUEModal: typeof DocumentSignedFTUEModal;
  DocumentTemplateUploadModal: typeof DocumentTemplateUploadModal;
  DocumentUploadModal: typeof DocumentUploadModal;
  EditOrganizationModal: typeof EditOrganizationModal;
  EditPaymentMethodModalV2: typeof EditPaymentMethodModalV2;
  EditProjectPaymentMethodModal: typeof EditProjectPaymentMethodModal;
  EditSocialLinksModal: typeof EditSocialLinksModal;
  ExitOpportunityChangesModal: typeof ExitOpportunityChangesModal;
  FileSupportRequestModal: typeof FileSupportRequestModal;
  FinanceIntegrationClientSubscriptionUpsellModal: typeof FinanceIntegrationClientSubscriptionUpsellModal;
  FinanceIntegrationSurveyModal: typeof FinanceIntegrationSurveyModal;
  GenericConfirmationModal: typeof GenericConfirmationModal;
  GoProBrandCustomizationModal: typeof GoProBrandCustomizationModal;
  GoProWaivePlatformFeesModal: typeof GoProWaivePlatformFeesModal;
  GuestJobApplicationVerifyEmailModal: typeof GuestJobApplicationVerifyEmailModal;
  GuestPaymentSuccessModal: typeof GuestPaymentSuccessModal;
  HireOptionsModal: typeof HireOptionsModal;
  IncompleteProfileModal: typeof IncompleteProfileModal;
  IndependentCongratsLiveProjectModal: typeof IndependentCongratsLiveProjectModal;
  IndyCompliantContractsEducationModal: typeof IndyCompliantContractsEducationModal;
  IndyDashboardWelcomeModal: typeof IndyDashboardWelcomeModal;
  IndyOnboardingAbandonFlowModal: typeof IndyOnboardingAbandonFlowModal;
  IndyOnboardingRedirectionModal: typeof IndyOnboardingRedirectionModal;
  IndyPortfolioSubscriptionModal: typeof IndyPortfolioSubscriptionModal;
  IndyPortfolioSubscriptionSuccessModal: typeof IndyPortfolioSubscriptionSuccessModal;
  IndySignUpAbandonFlowModal: typeof IndySignUpAbandonFlowModal;
  InviteContactModal: typeof InviteContactModal;
  InvitedContractorCompanyCollaborationModal: typeof InvitedContractorCompanyCollaborationModal;
  InviteTeammatesModal: typeof InviteTeammatesModal;
  JobApplicationSocialShareModal: typeof JobApplicationSocialShareModal;
  JobCreationModal: typeof JobCreationModal;
  JobOrContestCreationModal: typeof JobOrContestCreationModal;
  JobPostingVisibilityModal: typeof JobPostingVisibilityModal;
  JustSubscribedToProModal: typeof JustSubscribedToProModal;
  LiveProjectCompleteOnboardingModal: typeof LiveProjectCompleteOnboardingModal;
  LogoutModal: typeof LogoutModal;
  ManageEntityOwnerModal: typeof ManageEntityOwnerModal;
  MarkApplicantAsContestantModal: typeof MarkApplicantAsContestantModal;
  MarkApplicantAsExpertModal: typeof MarkApplicantAsExpertModal;
  MarkContestantAsWinnerModal: typeof MarkContestantAsWinnerModal;
  MessageSentModal: typeof MessageSentModal;
  MoreReviewsModal: typeof MoreReviewsModal;
  NewFeaturesUnlockedModal: typeof NewFeaturesUnlockedModal;
  PaymentMethodAttachedToProjectsModal: typeof PaymentMethodAttachedToProjectsModal;
  PendingPaymentLoadingStateModal: typeof PendingPaymentLoadingStateModal;
  PostJobBoostSubscribeModal: typeof PostJobBoostSubscribeModal;
  PrimarySkillChangedWarningModal: typeof PrimarySkillChangedWarningModal;
  ProfileMagicInputErrorModal: typeof ProfileMagicInputErrorModal;
  ProfileMagicInputModal: typeof ProfileMagicInputModal;
  ProjectInReviewModal: typeof ProjectInReviewModal;
  ProposalBillingTypeEducationModal: typeof ProposalBillingTypeEducationModal;
  ProposalEscrowBillingEducationModal: typeof ProposalEscrowBillingEducationModal;
  ProposalInvoiceBillingEducationModal: typeof ProposalInvoiceBillingEducationModal;
  ReadyToSubmitConfirmationModal: typeof ReadyToSubmitConfirmationModal;
  RecoverUnsavedChangesModal: typeof RecoverUnsavedChangesModal;
  ReferralC4cInviteModal: typeof ReferralC4cInviteModal;
  ReferralInviteModal: typeof ReferralInviteModal;
  RemoveContactWarningModal: typeof RemoveContactWarningModal;
  RemoveWorkspaceMemberModal: typeof RemoveWorkspaceMemberModal;
  ReplySocialPost: typeof ReplySocialPost;
  RequestMembershipModal: typeof RequestMembershipModal;
  RequestProposalRevisionModal: typeof RequestProposalRevisionModal;
  RequestRevisionOngoingProjectSubmissionModal: typeof RequestRevisionOngoingProjectSubmissionModal;
  RequestToWorkModal: typeof RequestToWorkModal;
  ResolveBulkPaymentCSVImportIssuesModal: typeof ResolveBulkPaymentCSVImportIssuesModal;
  SampleDestructiveModal: typeof SampleDestructiveModal;
  SampleFullscreenMobileModal: typeof SampleFullscreenMobileModal;
  SampleHeroImageModal: typeof SampleHeroImageModal;
  SampleRegularModal: typeof SampleRegularModal;
  SaveAsDraftModal: typeof SaveAsDraftModal;
  SaveUserSignUpModal: typeof SaveUserSignUpModal;
  ScheduleInvoicePaymentModal: typeof ScheduleInvoicePaymentModal;
  SearchFiltersModal: typeof SearchFiltersModal;
  SearchPreviewEndedModal: typeof SearchPreviewEndedModal;
  SelectProjectsModal: typeof SelectProjectsModal;
  SendDocumentModal: typeof SendDocumentModal;
  ServiceInquiryModal: typeof ServiceInquiryModal;
  ShareAndInviteToJobModal: typeof ShareAndInviteToJobModal;
  ShareSocialPostModal: typeof ShareSocialPostModal;
  SlideOutWorkspaceMemberModal: typeof SlideOutWorkspaceMemberModal;
  SocialPostEngagementModal: typeof SocialPostEngagementModal;
  SocialPostImagesModal: typeof SocialPostImagesModal;
  SocialPostOnboardingModal: typeof SocialPostOnboardingModal;
  SubmitMilestoneModal: typeof SubmitMilestoneModal;
  SubmittedContestEntryModal: typeof SubmittedContestEntryModal;
  SuccessfulBonusPaymentModal: typeof SuccessfulBonusPaymentModal;
  UpdateAvailabilityModal: typeof UpdateAvailabilityModal;
  UpdateJobDetailsBeforePostingModal: typeof UpdateJobDetailsBeforePostingModal;
  UserAvailabilityModal: typeof UserAvailabilityModal;
  VideoModal: typeof VideoModal;
  ViewOwnJobApplicationModal: typeof ViewOwnJobApplicationModal;
  WelcomeToYourCompanyProfileModal: typeof WelcomeToYourCompanyProfileModal;
  WorkspaceDocumentTemplatesModal: typeof WorkspaceDocumentTemplatesModal;
};

export const MODAL_ANALYTICS_NAMES: Record<
  ModalTemplateKeys,
  PropertyModalName
> = {
  AbandonEditableFlowModal: 'abandon_editable_flow',
  AcceptInvoiceTermsModal: 'accept_invoice_terms_modal',
  AddContactModal: 'add_contact_modal',
  AddNewProjectModal: 'add_new_project_modal',
  AddOrganizationModal: 'add_organization_modal',
  AddTaxInformationModal: 'add_tax_information_modal',
  AddTaxInformationToProjectTermsModal:
    'add_tax_information_to_project_terms_modal',
  AddToUserListsModal: 'add_to_user_lists_modal',
  AdvancedNetworkUpgradeModal: 'client_workspace_upgrade_to_advanced_network',
  AdvancedSearchUpgradeModal: 'advanced_search_upgrade_modal',
  AnonymousJobCreationModal: 'anonymous_job_creation_modal',
  AppliedToContestModal: 'applied_to_contest_modal',
  ApplyToJobModal: 'demand_job_apply_to_posting',
  ApplyToJobUnauthenticatedModal: 'demand_job_apply_to_job_unauthenticated',
  ApproveMilestoneModal: 'approve_milestone_modal',
  ApproveWorkConfirmationModal: 'c4c_approve_work_confirmation_modal',
  AuthenticationModal: 'demand_authentication_modal',
  BonusFormModal: 'work_send_bonus_modal',
  BoostedJobsModal: 'boosted_jobs_modal',
  BoostSocialPostModal: 'boost_social_post_modal',
  BoostYourApplicationModal: 'boost_your_application_modal',
  BrandCustomizationModal: 'brand_customization_modal',
  BrandCustomizationSuccessModal: 'brand_customization_success_modal',
  CancelContraProModal: 'cancel_contra_pro_warning_modal',
  CancelDisputeProjectModal: 'c4c_cancel_dispute_project_modal',
  ClientCongratsLiveProjectModal: 'c4c_client_congrats_live_project',
  ClientCreditIssuanceModal: 'client_issuance_modal',
  ClientOnboardingAbandonFlowModal: 'growth_onboarding-abandon-flow-client',
  ClientOnboardingRedirectionModal: 'client_continue_signup',
  ClientSignUpAbandonFlowModal: 'growth_signup-abandon-flow-client',
  ClientSubscriptionCustomizationModal:
    'client_subscription_customization_modal',
  ClientWorkspaceSubscriptionModal: 'client_workspace_subscription_modal',
  ClientWorkspaceSubscriptionSuccessModal:
    'client_workspace_subscription_success_modal',
  CompleteSignUpModal: 'complete_sign_up_modal',
  CompliantContractsEducationModal: 'compliant_contracts_education_modal',
  DeclineMilestoneModal: 'decline_milestone_modal',
  DeclineProposalChangeRequestModal: 'decline_proposal_change_request_modal',
  DeclineWorkConfirmationModal: 'work_confirm_decline_submitted_work_modal',
  DeleteAccountModal: 'delete_account_modal',
  DeleteChatMessageWarningModal: 'delete_chat_message_warning_modal',
  DeleteDomainConfirmationModal: 'delete_domain_confirmation_modal',
  DeleteNetworkViewModal: 'delete_network_view_modal',
  DeletePaymentMethodModal: 'delete_payment_method_modal',
  DeleteResourceModal: 'delete_resource_modal',
  DeleteUserListModal: 'delete_user_list_modal',
  DeleteWorkspaceDocumentModal: 'delete_workspace_document_modal',
  DemoBookedModal: 'demo_booked_modal',
  DepositMilestonePaymentModal: 'deposit_milestone_payment_modal',
  DisableWorkWithMeConfirmationModal: 'disable_work_with_me_confirmation_modal',
  DiscardChangesModal: 'discard_changes_modal',
  DiscardConfirmationModal: 'c4c_discard_confirmation_modal',
  DiscoverabilityEducationModal: 'discoverability_education_modal',
  DiscoverableOnContraModal: 'discoverable_on_contra_modal',
  DiscoverUnauthenticatedInquiryModal: 'unauthenticated_inquiry_modal',
  DocumentSignedFTUEModal: 'document_signed_ftue_modal',
  DocumentTemplateUploadModal: 'document_template_upload_modal',
  DocumentUploadModal: 'document_upload_modal',
  EditOrganizationModal: 'edit_organization_modal',
  EditPaymentMethodModalV2: 'edit_payment_method_modal_v2',
  EditProjectPaymentMethodModal: 'edit_project_payment_method',
  EditSocialLinksModal: 'edit_social_links_modal',
  ExitOpportunityChangesModal: 'exit_opportunity_changes_modal',
  FileSupportRequestModal: 'coin_submit_support_request',
  FinanceIntegrationClientSubscriptionUpsellModal:
    'finance_integration_client_subscription_upsell_modal',
  FinanceIntegrationSurveyModal: 'finance_integration_survey_modal',
  GenericConfirmationModal: 'confirmation_modal',
  GoProBrandCustomizationModal: 'go_pro_brand_customization_modal',
  GoProWaivePlatformFeesModal: 'go_pro_waive_platform_fees_modal',
  GuestJobApplicationVerifyEmailModal:
    'guest_job_application_verify_email_modal',
  GuestPaymentSuccessModal: 'work_guest_checkout_successful',
  HireOptionsModal: 'client_home_how_do_you_want_to_hire',
  IncompleteProfileModal: 'incomplete_profile_modal',
  IndependentCongratsLiveProjectModal: 'c4c_independent_congrats_live_project',
  IndyCompliantContractsEducationModal:
    'indy_compliant_contracts_education_modal',
  IndyDashboardWelcomeModal: 'indy_dashboard_welcome_modal',
  IndyOnboardingAbandonFlowModal: 'growth_onboarding-abandon-flow-independent',
  IndyOnboardingRedirectionModal: 'independent_continue_signup',
  IndyPortfolioSubscriptionModal: 'indy_portfolio_subscription_modal',
  IndyPortfolioSubscriptionSuccessModal:
    'indy_portfolio_subscription_success_modal',
  IndySignUpAbandonFlowModal: 'growth_signup-abandon-flow-independent',
  InviteContactModal: 'invite_contact_modal',
  InvitedContractorCompanyCollaborationModal:
    'invited_contractor_company_collaboration_modal',
  InviteTeammatesModal: 'invite_teammates_modal',
  JobApplicationSocialShareModal: 'job_application_social_share_modal',
  JobCreationModal: 'demand_create_job',
  JobOrContestCreationModal: 'job_or_contest_creation_modal',
  JobPostingVisibilityModal: 'job_posting_visibility_modal',
  JustSubscribedToProModal: 'just_subscribed_to_pro_modal',
  LiveProjectCompleteOnboardingModal: 'live_project_complete_onboarding_modal',
  LogoutModal: 'logout_modal',
  ManageEntityOwnerModal: 'manage_entity_owner_modal',
  MarkApplicantAsContestantModal: 'mark_applicant_as_contestant_modal',
  MarkApplicantAsExpertModal: 'mark_applicant_as_expert_modal',
  MarkContestantAsWinnerModal: 'mark_contestant_as_winner_modal',
  MessageSentModal: 'demand_message_sent_modal',
  MoreReviewsModal: 'more_reviews_modal',
  NewFeaturesUnlockedModal: 'new_features_unlocked_modal',
  PaymentMethodAttachedToProjectsModal: 'payment_method_attached_to_projects',
  PendingPaymentLoadingStateModal: 'pending_payment_loading_state_modal',
  PostJobBoostSubscribeModal: 'post_job_boost_subscribe_modal',
  PrimarySkillChangedWarningModal: 'primary_skill_changed_warning_modal',
  ProfileMagicInputErrorModal: 'growth_profile_magic_questions_input_error',
  ProfileMagicInputModal: 'growth_profile_magic_questions_input',
  ProjectInReviewModal: 'project_in_review',
  ProposalBillingTypeEducationModal: 'proposal_billing_type_education_modal',
  ProposalEscrowBillingEducationModal:
    'proposal_escrow_billing_education_modal',
  ProposalInvoiceBillingEducationModal:
    'proposal_invoice_billing_education_modal',
  ReadyToSubmitConfirmationModal: 'work_submit_work_for_approval_modal',
  RecoverUnsavedChangesModal: 'recover_unsaved_changes',
  ReferralC4cInviteModal: 'referral_c4c_invite_modal',
  ReferralInviteModal: 'referral_invite_modal',
  RemoveContactWarningModal: 'remove_contact_warning_modal',
  RemoveWorkspaceMemberModal: 'remove_workspace_member_modal',
  ReplySocialPost: 'reply_social_post',
  RequestMembershipModal: 'request_membership_modal',
  RequestProposalRevisionModal: 'c4c_request_proposal_revision_modal',
  RequestRevisionOngoingProjectSubmissionModal:
    'core_request_revision_ongoing_project_submission',
  RequestToWorkModal: 'growth_request_to_work_modal',
  ResolveBulkPaymentCSVImportIssuesModal:
    'resolve_bulk_payment_csv_import_issues_modal',
  SampleDestructiveModal: 'sample_destructive_modal',
  SampleFullscreenMobileModal: 'sample_fullscreen_mobile_modal',
  SampleHeroImageModal: 'sample_hero_image_modal',
  SampleRegularModal: 'sample_regular_modal',
  SaveAsDraftModal: 'save_as_draft_modal',
  SaveUserSignUpModal: 'save_user_sign_up_modal',
  ScheduleInvoicePaymentModal: 'schedule_invoice_payment_modal',
  SearchFiltersModal: 'demand_search_filters_modal',
  SearchPreviewEndedModal: 'search_preview_ended_modal',
  SelectProjectsModal: 'linked_project_modal',
  SendDocumentModal: 'send_document_modal',
  ServiceInquiryModal: 'demand_service_inquiry_modal',
  ShareAndInviteToJobModal: 'share_and_invite_to_job_modal',
  ShareSocialPostModal: 'share_social_post_modal',
  SlideOutWorkspaceMemberModal: 'slide_out_workspace_member_modal',
  SocialPostEngagementModal: 'social_post_engagement_modal',
  SocialPostImagesModal: 'social_post_images_modal',
  SocialPostOnboardingModal: 'social_post_onboarding_modal',
  SubmitMilestoneModal: 'submit_milestone_modal',
  SubmittedContestEntryModal: 'submitted_contest_entry_modal',
  SuccessfulBonusPaymentModal: 'work_bonus_checkout_successful',
  UpdateAvailabilityModal: 'update_availability_modal',
  UpdateJobDetailsBeforePostingModal:
    'demand_update_job_details_before_posting_modal',
  UserAvailabilityModal: 'demand_user_availability_reminder',
  VideoModal: 'video_player_modal',
  ViewOwnJobApplicationModal: 'demand_job_view_own_application',
  WelcomeToYourCompanyProfileModal: 'welcome_to_your_company_profile_modal',
  WorkspaceDocumentTemplatesModal: 'workspace_document_templates_modal',
};
